import locale from "localization/en";
import styles from "../order-summary.module.scss";
export const fuelColumns = [
  {
    key: "product",
    tdClassName: styles.alignToTop,
    text: locale.product,
    style: {
      width: "100px",
    },
  },
  {
    key: "currentInventoryLevel",
    text: locale.currentInventoryLevel,
  },
  {
    key: "orderVolume",
    text: locale.orderVolume,
  },
  {
    key: "amountInPhp",
    text: locale.amountInPhp,
  },
];

export const nonFuelColumns = [
  {
    key: "sku",
    text: locale.sku,
    tdClassName: styles.alignToCenter,
  },
  {
    key: "product",
    text: locale.product,
    tdClassName: styles.alignToCenter,
  },
  {
    key: "variant",
    text: locale.variant,
    tdClassName: styles.alignToCenter,
  },
  {
    key: "category",
    text: locale.productCategory,
  },
  {
    key: "quantityBeforeReceiving",
    text: locale.quantityBeforeReceiving,
    style: {
      margin: "10px 0px",
    },
  },
  {
    key: "quantityDelivered",
    text: locale.quantityDelivered,
  },
  {
    key: "quantityAfterReceiving",
    text: locale.quantityAfterReceiving,
  },
  {
    key: "variance",
    text: locale.variance,
    tdClassName: styles.alignToCenter,
  },
  {
    key: "actions",
    text: locale.actions,
    tdClassName: styles.alignToCenter,
  },
];
